module.exports = __webpack_public_path__ + "img/custom-storefronts-2.6ab550e6.png";